<template>
  <!-- 成功 失败 弹窗 -->
  <van-popup
    v-model:show="visible"
    :position="position"
    :close-on-click-overlay="closeOnClickOverlay"
    teleport="body"
  >
    <div v-if="lightBg" class="light-bg">
      <img class="light-img" :src="getImageUrlWithCDN_TEST('/activity/dia-bg1.png')" alt="" />
      <img class="light-img1" :src="getImageUrlWithCDN_TEST('/activity/dia-bg2.png')" alt="" />
    </div>
    <div class="popup-view" :style="popupStyle">
      <div v-if="title && title !== null" class="popup-view__header">
        <p class="popup-view__header__title">{{ title }}</p>
      </div>
      <slot v-else name="header"></slot>
      <slot name="content"></slot>
    </div>

    <slot name="other"></slot>

    <div
      v-if="closeable"
      class="close-container chxy-row-c-c"
      :class="{ 'close-container--corner': closePlacement === 'top-right' }"
      @click="closePopup"
    >
      <van-icon
        :name="closePlacement === 'top-right' ? 'cross' : 'close'"
        :size="closePlacement === 'top-right' ? 20 : 29"
        color="var(--white)"
      />
    </div>
  </van-popup>
</template>

<script setup>
const visible = ref(false)
const props = defineProps({
  closeType: { type: String, default: 'default' },
  title: { type: String, default: '' },
  position: { type: String, default: 'center' },
  closeable: { type: Boolean, default: true },
  closePlacement: { type: String, default: '' },
  lightBg: { type: Boolean, default: false },
  closeOnClickOverlay: { type: Boolean, default: false },
  padding: { type: [Number, String], default: 10 },
  radius: { type: [Number, String], default: 15 },
  background: { type: String, default: '' },
  borderSize: { type: [Number, String], default: 1 },
  borderColor: { type: String, default: '' },
})

const popupStyle = computed(() => {
  const obj = {
    padding: !isNaN(props.padding) ? `${props.padding}px` : props.padding,
    'border-radius': `${props.radius}px`,
    'border-width': `${props.borderSize}px`,
  }

  if (props.background && props.background !== null && props.background !== '') {
    obj['background-color'] = props.background
  }
  if (props.borderColor && props.borderColor !== null && props.borderColor !== '') {
    obj['border-color'] = props.borderColor
  }

  return obj
})

const open = () => {
  visible.value = true
}

const close = () => {
  emit('close')
  visible.value = false
}

const manualClose = () => {
  emit('manualClose')
  visible.value = false
}

const openPopupClose = () => {
  open()
}

const closePopup = () => {
  switch (props.closeType) {
    case 'manual':
      manualClose()
      break
    default:
      close()
  }
}

const emit = defineEmits(['close'])

defineExpose({ open, close, manualClose, openPopupClose, closePopup })
</script>

<style scoped lang="scss">
.popup-view {
  position: relative;
  background-color: var(--popup-primary-bg);
  border-style: solid;
  border-color: var(--popup-primary-border);
  overflow-y: visible;

  &__header {
    width: 100%;
    height: 24px;
    font-size: 16px;
    text-align: center;
    color: var(--popup-primary-title);
    line-height: 24px;
  }
}
.close-container {
  margin-top: 10px;
}
.close-container--corner {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  margin-top: 0;
  cursor: pointer;
}
.light-bg {
  position: relative;
  width: 270px;
  height: 126px;
  margin: 0 auto;
  .light-img {
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
  .light-img1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
  }
}
</style>
